/**
* @file 资源管理-司机资源
* */
<template>
  <div id="driver">
    <custom-table 
      ref="customTable" 
      :has-channel="true" 
      :has-organization="true"
      :customOptions="pageConfig.customOptions" 
      :columns="pageConfig.columns" 
      :import-columns="pageConfig.importColumns"
      :import-rules="pageConfig.importRules" 
      importDes="手机号码-证件名称，例如：13555544485-驾驶证" 
      :importRemark="pageConfig.importRemark"
      :import-excel="pageConfig.importExcel" 
      :excel-type="pageConfig.excelType" 
      addText="创建司机" 
      @addFn="addFn">
      <template slot="customTable-top">
        <div class="flex" style="padding-bottom: 16px; justify-content: space-between;">
          <el-radio-group v-model="status" @change="statusChange">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button label="1">正常</el-radio-button>
            <el-radio-button label="2">封禁</el-radio-button>
          </el-radio-group>
          <div>司机余额： <span style="font-size: 18px;font-weight: bold;">{{ balance }}</span>元</div>
        </div>
      </template>
      <template slot="table-operation">
        <el-table-column label="操作" width="120" fixed="right">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" @click="compileClick(row)">查看</el-button>
            <el-dropdown @command="handleCommand($event, row)">
              <span class="el-dropdown-link">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="pwdClick">
                  密码
                </el-dropdown-item>
                <el-dropdown-item command="settlementClick" v-if="btnPreFn($route.name + '_settlement', false)">
                  结算
                </el-dropdown-item>
                <el-dropdown-item command="removeClick">
                  删除
                </el-dropdown-item>
                <el-dropdown-item command="updateIsEnable"
                  v-if="btnPreFn($route.name + '_freeze', false) && row.isEnable == 1">
                  封禁
                </el-dropdown-item>
                <el-dropdown-item command="updateIsEnable"
                  v-if="btnPreFn($route.name + '_freeze', false) && row.isEnable == 2">
                  解封
                </el-dropdown-item>

                <el-dropdown-item command="rechargeClick" v-if="btnPreFn($route.name + '_recharge', false)">
                  充值
                </el-dropdown-item>
                <!--                -->
                <el-dropdown-item v-if="btnPreFn($route.name + '_balance', false)" command="balanceClick">
                  明细
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="['created', 'auditTime', 'lastLoginTime'].includes(item.prop)">{{ row[item.prop] | filterTime }}
        </template>
        <div v-else-if="item.prop === 'name'" class="avatar-name">
          <img class="avatar-img" v-if="row.headPortrait" :src="mixinQiniuImg(row.headPortrait)"/>
          <span @dblclick="$utils.dblclickCopy">{{ row.name }}</span> <el-tag
            style="margin-left: 4px;" v-if="row.isEnable == 2" type="danger">{{ !row.disableType ? '永久封禁' : row.disableType == 2 ? '永久封禁' :
              `封禁${row.disableDays}天` }}</el-tag>
        </div>
        <div v-else-if="item.prop === 'licenseNo'">
          <span 
            v-if="row.licenseNo"
            :style="getPlateStyle(row.licenseNo)"
            @dblclick="$utils.dblclickCopy"
          >{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else style="color: #999">{{ mixinUserInfo.platformType == 1 || mixinUserInfo.platformType == 2 ? "-" : "未绑定车辆" }}</span>
        </div>
        <template v-else-if="item.prop === 'balance'">
          <span class="util-money">￥{{ (row.balance + row.noBalance).toFixed(2) || 0 }}</span>
        </template>
        <template v-else-if="item.prop === 'totalIncome'">
          <span class="util-money">￥{{ row.totalIncome ? Number(row.totalIncome).toFixed(2) : '0.00' }}</span>
        </template>
        <template v-else-if="item.prop === 'orderCount'">
          <span>{{ row.orderCount || 0 }}</span>
        </template>
        <template v-else-if="item.prop === 'avgScore'">
          <el-rate :value="row.avgScore || 0" disabled allow-half size="mini" />
        </template>
        <template v-else-if="item.prop === 'onlineStatus'">
          <el-tag :type="row.onlineStatus == 1 ? 'success' : 'info'" size="mini">
            {{ row.onlineStatus == 1 ? '听单中' : '休息中' }}
          </el-tag>
        </template>
        <template v-else>
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
        </template>
      </template>
      <template slot="importColumn" slot-scope="{ item, row }">
        <div v-if="
          item.prop === 'idCardFrontPath' ||
          item.prop === 'driverLicensePath' ||
          item.prop === 'idCardBackPath' ||
          item.prop === 'qualificationsPath'
        ">
          <img class="column-img" v-if="row[item.prop]" :src="mixinQiniuImg(row[item.prop])" />
          <div class="no-upload" v-else>未上传</div>
        </div>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

    <el-dialog title="司机余额充值" :before-close="handClose" :visible.sync="showRecharge" destroy-on-close width="350px">
      <driverRecharge v-if="showRecharge" :driverData="driverData" @handClose="handClose"></driverRecharge>
    </el-dialog>

    <el-drawer :visible.sync="showRechargeList" destroy-on-close :before-close="handClose" size="70%">
      <driverRechargeList @handClose="handClose" v-if="showRechargeList" :driverData="driverData"></driverRechargeList>
    </el-drawer>

    
    <el-drawer :visible.sync="showDzCreate" destroy-on-close :wrapperClosable="false" :before-close="handClose" size="50%">
      <DzCreate @success="handleSuccess" @cancel="handClose" title="创建司机"></DzCreate>
    </el-drawer>

    <driverBan @submitBan="submitBan" :driverId="driverData.id" :show="showBan" @close="handClose" :loading="banLoading">
    </driverBan>
    <editPwd :show="showPwd" @submit="submitPwd" @close="handClose"></editPwd>
  </div>
</template>

<script>
import driverSupervise from "../components/driverSupervise";
import driverRecharge from "../components/driverRecharge";
import driverRechargeList from "../components/driverRechargeList";
import driverBan from "../components/driverBan";
import editPwd from "../components/editPwd";
import { cityCodeJson } from "@/assets/js/city";
import DzCreate from './DzCreate'
export default {
  name: "driver",
  components: {
    driverSupervise,
    driverRecharge,
    driverRechargeList,
    driverBan,
    editPwd,
    DzCreate
  },
  data() {
    let arr = [];
    cityCodeJson.forEach((pre) => {
      if (pre.districts) {
        arr.push(...pre.districts);
      }
    });
    arr.forEach((item) => {
      item.label = item.name;
      item.value = item.citycode;
    });
    return {
      cityList: arr,
      showRecharge: false,
      showRechargeList: false,
      driverData: {},
      status: '',
      balance: 0,
      banLoading: false,
      showBan: false,
      showPwd: false,
      showDzCreate: false
    };
  },
  computed: {
    pageConfig() {
      let importExcel = ''
      let excelType = ''
      let importRemark = []
      let customOptions = {
        url: '',
        params: {
          page: 1,
          size: 20
        },
        search: []
      }
      let columns = []
      let importRules = ["idCardFrontPath", "idCardBackPath", "driverLicensePath"]
      let importColumns = []
      switch (this.mixinUserInfo.platformType) {
        case 1:
          importExcel = this.mixinUserInfo.organizationType === 1 ? '/drivers.xlsx' : '/driver.xlsx'
          excelType = 'Driver'
          importRemark = ['驾驶证长期有效，驾驶证有效期请填写20991231']
          customOptions = {
            url: "/api/v1/manage/driver",
            params: {
              page: 1, // 页数
              size: 20, // 每页条数
            },
            search: [
              {
                type: "input",
                field: "name",
                name: "司机名称",
                value: "",
              },
              {
                type: "input",
                field: "phone",
                name: "手机号码",
                value: "",
              },
              {
                type: "input",
                field: "idCard",
                name: "身份证号",
                value: "",
              },
              {

                type: "input",
                field: "companyName",
                name: "公司",
                value: "",
              },
              // {

              //   type: "input",
              //   field: "licenseNo",
              //   name: "车辆车辆号牌码",
              //   value: "",
              // },
            ],
          }
          columns = [
            { prop: "name", label: "司机姓名", width: 150 },
            { prop: "phone", label: "手机号码" },
            { prop: "idCard", label: "身份证号", width: 180 },
            { prop: "licenseNo", label: "车辆号牌", width: 160 },
            { prop: "balance", label: "钱包余额",width: 80   },
            { prop: "orderCount", label: "完成订单数", width: 100 },
            { prop: "totalIncome", label: "累计收入", width: 100 },
            { prop: "avgScore", label: "平均评分", width: 130 },
            { prop: "created", label: "注册时间",width: 130  },
            { prop: "lastLoginTime", label: "最近登录时间",width: 130   },
            { prop: "companyName", label: "公司",width: 160   },
            { prop: "appVersion", label: "司机端版本" ,width: 80  },
          ]
          importRules = ["idCardFrontPath", "idCardBackPath", "qualificationsPath"]
          importColumns = [
            { prop: "name", label: "司机名称", required: true },
            { prop: "phone", width: 120, label: "手机号码", required: true },
            { prop: "idCard", width: 160, label: "身份证号", required: true },
            { prop: "password", label: "登录密码", required: true },
            { prop: "organizationName", label: "机构名称", required: true },
            {
              prop: "idCardFrontPath",
              width: 120,
              label: "身份证正面",
              required: true,
            },
            {
              prop: "idCardBackPath",
              width: 120,
              label: "身份证背面",
              required: true,
            },
            { prop: "driverLicensePath", label: "驾驶证", required: true, },
            {
              prop: "qualificationsPath",
              width: 120,
              label: "从业资格证",
              required: true,
            },
          ]
          break
        case 2:
          importExcel = this.mixinUserInfo.organizationType === 1 ? '/drivers.xlsx' : '/driver.xlsx'
          excelType = 'Driver'
          importRemark = ['驾驶证长期有效，驾驶证有效期请填写20991231']
          customOptions = {
            url: "/api/v1/manage/driver",
            params: {
              page: 1, // 页数
              size: 20, // 每页条数
            },
            search: [
              {
                type: "input",
                field: "name",
                name: "司机名称",
                value: "",
              },
              {
                type: "input",
                field: "phone",
                name: "手机号码",
                value: "",
              },
              {
                type: "input",
                field: "idCard",
                name: "身份证号",
                value: "",
              },
              {

                type: "input",
                field: "companyName",
                name: "公司",
                value: "",
              },
              // {
              //   type: "input",
              //   field: "licenseNo",
              //   name: "车辆车辆号牌码",
              //   value: "",
              // },
            ],
          }
          columns = [
            { prop: "name", label: "司机姓名", width: 150 },
            { prop: "phone", label: "手机号码" },
            { prop: "idCard", label: "身份证号", width: 180 },
            { prop: "licenseNo", label: "车辆号牌", width: 200 },
            { prop: "balance", label: "钱包余额" },
            { prop: "orderCount", label: "完成订单数", width: 100 },
            { prop: "totalIncome", label: "累计收入", width: 100 },
            { prop: "avgScore", label: "平均评分", width: 90 },
            { prop: "created", label: "注册时间" },
            { prop: "lastLoginTime", label: "最近登录时间" },
            { prop: "companyName", label: "公司" },
            { prop: "appVersion", label: "司机端版本" },
          ]
          importRules = ["idCardFrontPath", "idCardBackPath", "qualificationsPath"]
          importColumns = [
            { prop: "name", label: "司机名称", required: true },
            { prop: "phone", width: 120, label: "手机号码", required: true },
            { prop: "idCard", width: 160, label: "身份证号", required: true },
            // { prop: "openingBank", width: 120, label: "开户行", required: true },
            // { prop: "bankCardNo", width: 160, label: "银行卡号", required: true },
            { prop: "password", label: "登录密码", required: true },
            { prop: "organizationName", label: "机构名称", required: true },
            {
              prop: "idCardFrontPath",
              width: 120,
              label: "身份证正面",
              required: true,
            },
            {
              prop: "idCardBackPath",
              width: 120,
              label: "身份证背面",
              required: true,
            },
            { prop: "driverLicensePath", label: "驾驶证", required: true, },
            {
              prop: "qualificationsPath",
              width: 120,
              label: "从业资格证",
              required: true,
            },
          ]
          break
        case 3:
          importExcel = this.mixinUserInfo.organizationType === 1 ? '/sfxDrivers.xlsx' : '/sfxDriver.xlsx'
          excelType = 'DriverHitchRide'
          importRemark = ['驾驶证长期有效，驾驶证有效期请填写20991231']
          customOptions = {
            url: "/api/v1/manage/driver/hitchRide",
            params: {
              page: 1,
              size: 20,
            },
            search: [
              {
                type: "input",
                field: "name",
                name: "司机名称",
                value: "",
              },
              {
                type: "input",
                field: "phone",
                name: "手机号码",
                value: "",
              },
              {
                type: "input",
                field: "idCard",
                name: "身份证号",
                value: "",
              },
              {
                type: "select",
                field: "receivingCityCode",
                name: "接单城市",
                value: "",
                option: this.cityList,
                clearable: true,
                filterable: true,
              },
            ],
          }
          columns = [
            { prop: "channelName", label: "归属渠道", width: 120 },
            { prop: "name", label: "司机姓名", width: 150 },
            { prop: "phone", label: "手机号码", width: 120 },
            { prop: "idCard", label: "身份证号", width: 180 },
            { prop: "licenseNo", label: "车辆号牌" },
            { prop: "balance", label: "钱包余额" },
            { prop: "orderCount", label: "完成订单数", width: 100 },
            { prop: "totalIncome", label: "累计收入", width: 100 },
            { prop: "avgScore", label: "平均评分", width: 90 },
            { prop: "onlineStatus", label: "接单状态", width: 90 },
            { prop: "created", label: "注册时间", width: 160 },
            { prop: "auditTime", label: "认证通过时间", width: 160 },
            { prop: "lastLoginTime", label: "最近上线时间", width: 160 },
            { prop: "receivingCity", label: "接单城市" },
            { prop: "appVersion", label: "司机端版本", width: 100 },
          ]
          importRules = ["idCardFrontPath", "idCardBackPath", "driverLicensePath"]
          importColumns = [
            { prop: "name", label: "司机名称", required: true },
            { prop: "phone", width: 120, label: "手机号码", required: true },
            { prop: "idCard", width: 160, label: "身份证号", required: true },
            { prop: "password", label: "登录密码", required: false },
            { prop: "organizationName", label: "机构名称", required: true },
            {
              prop: "idCardFrontPath",
              width: 120,
              label: "身份证正面",
              required: true,
            },
            {
              prop: "idCardBackPath",
              width: 120,
              label: "身份证背面",
              required: true,
            },
            { prop: "driverLicensePath", label: "驾驶证", required: true },
            { prop: "driverClass", label: "准驾车型", required: true },
            {
              prop: "firstIssueDate",
              width: 140,
              label: "驾驶证初次领证日期",
              required: false,
            },
            {
              prop: "driverLicenceValid",
              width: 120,
              label: "驾驶证有效期",
              required: false,
            },
          ]
          break
        case 4:
          importExcel = this.mixinUserInfo.organizationType === 1 ? '/sfxDrivers.xlsx' : '/sfxDriver.xlsx'
          excelType = 'DriverAirport'
          importRemark = ['驾驶证长期有效，驾驶证有效期请填写20991231']
          customOptions = {
            url: "/api/v1/manage/driver/airport",
            params: {
              page: 1, // 页数
              size: 20, // 每页条数
            },
            search: [
              {
                type: "input",
                field: "name",
                name: "司机名称",
                value: "",
              },
              {
                type: "input",
                field: "phone",
                name: "手机号码",
                value: "",
              },
              {
                type: "input",
                field: "idCard",
                name: "身份证号",
                value: "",
              },
              {
                type: "select",
                field: "receivingCityCode",
                name: "接单城市",
                value: "",
                option: this.cityList,
                clearable: true,
                filterable: true,
              },
            ],
          }
          columns = [
            { prop: "name", label: "司机姓名", width: 150 },
            { prop: "phone", label: "手机号码" },
            { prop: "idCard", label: "身份证号", width: 180 },
            { prop: "licenseNo", label: "车辆号牌" },
            { prop: "balance", label: "钱包余额" },
            { prop: "created", label: "注册时间", width: 160 },
            { prop: "auditTime", label: "认证通过时间", width: 160 },
            { prop: "lastLoginTime", label: "最近上线时间", width: 160 },
            { prop: "receivingCity", label: "接单城市" },
            { prop: "appVersion", label: "司机端版本", width: 100 },
          ]
          importRules = ["idCardFrontPath", "idCardBackPath", "driverLicensePath"]
          importColumns = [
            { prop: "name", label: "司机名称", required: true },
            { prop: "phone", width: 120, label: "手机号码", required: true },
            { prop: "idCard", width: 160, label: "身份证号", required: true },
            { prop: "password", label: "登录密码", required: false },
            { prop: "organizationName", label: "机构名称", required: true },
            {
              prop: "idCardFrontPath",
              width: 120,
              label: "身份证正面",
              required: true,
            },
            {
              prop: "idCardBackPath",
              width: 120,
              label: "身份证背面",
              required: true,
            },
            { prop: "driverLicensePath", label: "驾驶证", required: true },
            { prop: "driverClass", label: "准驾车型", required: true },
            {
              prop: "firstIssueDate",
              width: 140,
              label: "驾驶证初次领证日期",
              required: false,
            },
            {
              prop: "driverLicenceValid",
              width: 120,
              label: "驾驶证有效期",
              required: false,
            },
          ]
          break
        default:
          importExcel = this.mixinUserInfo.organizationType === 1 ? '/drivers.xlsx' : '/driver.xlsx'
          excelType = 'Driver'
      }
      return {
        importExcel,
        excelType,
        importRemark,
        customOptions,
        columns,
        importRules,
        importColumns
      }
    }
  },
  created() {
    this.getBalance();
  },
  methods: {
    handleSuccess() {
      this.handClose();
      this.$refs.customTable.listFn();
    },
    // 获取右上角司机余额
    getBalance() {
      let url = '/api/v1/manage/driver/hitchRide/balance';
      this.$axios.get(url).then(res => {
        if (res.code == 1) {
          this.balance = res.data;
        }
      });
    },
    // 封禁状态查询
    statusChange() {
      this.pageConfig.customOptions.params.page = 1;
      this.pageConfig.customOptions.params.isEnable = this.status;
      this.$refs.customTable.listFn();
    },
    handClose() {
      this.driverData = {};
      this.showRecharge = false;
      this.showRechargeList = false;
      this.showBan = false;
      this.showPwd = false;
      this.showDzCreate = false;
    },
     // 点击下拉按钮
     handleCommand(e, row) {
      this[e](row);
    },
    // 打开明细
    balanceClick(row) {
      this.driverData = row;
      this.showRechargeList = true;
    },
    // 打开充值
    rechargeClick(row) {
      this.driverData = row;
      this.showRecharge = true;
    },
   
    /**
     * 点击创建司机
     */
    addFn() {
      if (!this.btnPreFn(this.$route.name + "_add")) {
        return;
      }
      if(this.mixinUserInfo.platformType === 1){
        this.showDzCreate = true
      }else{
        this.$router.push("/createDriver");
      }
    },
    // 查询司机是否绑定车辆
    async isBinding(row) {
      let url = "/api/v1/manage/driver/binding";
      let params = {
        id: row.id,
      };
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        return data.data;
      }
    },
    // 封禁/解封
    async updateIsEnable(row) {
      this.driverData = { ...row }
      if (row.isEnable == 1) {
        this.showBan = true;
      } else {
        let text = row.disableType == 1 ? `当前司机因：${row.disableReason || 'xx'}原因封禁至${this.$utils.timeFn(row.disableEndTime, 'YYYY-MM-DD HH:mm')}，是否确认提前解除封禁？`
          : `当前司机因：${row.disableReason || 'xx'}原因永久封禁，是否确认解封？`
        this.$confirm(text, '解封司机')
          .then(async () => {
            let url = "/api/v1/manage/driver/changeEnableStatus";
            let params = {
              id: row.id,
              isEnable: 1,
            };
            let data = await this.$axios.put(url, params);
            if (data && data.code === 1) {
              this.$message.success("司机已解封");
              this.$refs.customTable.listFn();
            }
          })
      }
    },
    // 确认封禁
    async submitBan(params) {
      this.banLoading = true;
      let url = "/api/v1/manage/driver/changeEnableStatus";
      let data = await this.$axios.put(url, params);
      if (data && data.code === 1) {
        this.$message.success("司机已封禁");
        this.handClose();
        this.$refs.customTable.listFn();
      }
      this.banLoading = false;
    },
    // 结算
    async settlementClick(row) {
      if (!row.balance) {
        this.$message.warning("司机钱包没有余额");
      } else {
        this.$confirm(
          "将司机全部余额申请结算，确定这样做吗？",
          "结算提示"
        ).then(async () => {
          let url = "/api/v1/manage/driver/settlement";
          let params = {
            driverId: row.id,
          };
          let data = await this.$axios.post(url, params);
          if (data && data.code === 1) {
            this.$message.success("已为司机申请结算，请在结算审核中查看");
            this.$refs.customTable.listFn();
          }
        });
      }
    },
    /**
     * 列表-删除
     */
    async removeClick(row) {
      if (!this.btnPreFn(this.$route.name + "_remove")) {
        return;
      }
      let state = await this.isBinding(row);
      let text = state
        ? "该司机已绑定车辆，删除后将自动解绑，确认删除吗？"
        : "确认删除该司机吗？";
      this.$confirm(text, "删除提示").then(async () => {
        let url = "/api/v1/manage/driver";
        let params = {
          id: row.id,
        };
        let data = await this.$axios.delete(url, params);
        if (data && data.code === 1) {
          this.$message.success("删除成功");
          this.$refs.customTable.listFn();
        }
      });
    },
    /**
     * 编辑司机
     */
    compileClick(row) {
      if (!this.btnPreFn(this.$route.name + "_edit")) {
        return;
      }
      this.$router.push({ path: "/driverDetail", query: { id: row.id } });
    },
    // 密码
    pwdClick(row) {
        this.driverData = { ...row }
        this.showPwd = true
    },
    // 提交密码
    async submitPwd(pwd) {
      let url = "/api/v1/manage/driver";
      let params = {
        id: this.driverData.id,
        password: pwd
      }
      let {code} = await this.$axios.put(url, params);
      if (code === 1) {
        this.$message.success("密码修改成功");
        this.handClose();
      }
    }
  },
};
</script>

<style lang="less">
#driver {
  // 顶部状态筛选和余额显示
  .el-radio-group {
    .el-radio-button__inner {
      border-radius: 6px;
      padding: 8px 16px;
    }
    
    .el-radio-button:first-child .el-radio-button__inner {
      border-radius: 6px 0 0 6px;
    }
    
    .el-radio-button:last-child .el-radio-button__inner {
      border-radius: 0 6px 6px 0;
    }
  }

  .avatar-name {
    display: flex;
    align-items: center;

    .avatar-img {
      width: 36px;
      height: 36px;
      background-color: #e4e7ed;
      border-radius: 50%;
      margin-right: 8px;
      object-fit: cover;
    }
    
    span {
      font-weight: 500;
      color: #303133;
    }
  }

  .column-img {
    width: 36px;
    height: 36px;
    border-radius: 4px;
    object-fit: cover;
  }

  // 操作按钮样式
  .custom-action {
    display: flex;
    align-items: center;
    gap: 8px;
    
    .el-button--text {
      padding: 0;
      color: #2B77FF;
      
      &:hover {
        color: #1a5fd9;
      }
    }
    
    .el-dropdown-link {
      color: #2B77FF;
      cursor: pointer;
      font-size: 12px;
      
      &:hover {
        color: #1a5fd9;
      }
      
      .el-icon-arrow-down {
        font-size: 12px;
      }
    }
  }

  // 余额显示
  .util-money {
    font-weight: 600;
    color: #F56C6C;
  }

  .tableScopeSwitch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff;
  }

  .el-switch__label * {
    font-size: 12px !important;
  }

  .tableScopeSwitch .el-switch__label--right {
    z-index: 1;
    right: -6px;
  }

  .tableScopeSwitch .el-switch__label--left {
    z-index: 1;
    left: 20px;
  }

  .tableScopeSwitch .el-switch__label.is-active {
    display: block;
  }

  .tableScopeSwitch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 50px !important;
  }

  // 弹窗和抽屉样式
  .el-dialog {
    border-radius: 8px;
    
    .el-dialog__header {
      padding: 16px 20px;
      border-bottom: 1px solid #ebeef5;
      
      .el-dialog__title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }
    }
    
    .el-dialog__body {
      padding: 20px;
    }
  }
}
</style>
